import { Box, Icon, Skeleton, Typography } from '@mui/material'
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import DetailsText from '../DetailsText'
import SingleStepper from 'components/reusable/AdxProgressStepper/SingleStepper'
import { useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  getOneUpskillApprovalList,
  postUpskillApproval,
} from 'services/api/modules/upskill/approval-center'
import { format } from 'date-fns'
import ApproveAndReasonModal from './ApproveAndReasonModal'
import AdxButton from 'components/custom/AdxButton'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const UpskillApprovalModal = ({
  isModalOpen,
  handleClose,
  handleOpen,
  status,
  setStatus,
  id,
  type,
}) => {
  const [approveModalState, setApproveModalState] = useState(false)
  const [rejectModalState, setRejectModalState] = useState(false)
  const formatDate = (inputDate) => {
    const formattedDate = format(new Date(inputDate), 'EEE, dd/MM/yyyy')
    return formattedDate
  }
  const formatDateNoDay = (inputDate) => {
    const formattedDate = format(new Date(inputDate), 'dd/MM/yyyy, h:mm a')
    return formattedDate
  }
  const {
    isLoading: approvalModalDataIsLoading,
    error: approvalModalDatadIsError,
    data: approvalModalData,
  } = useQuery(
    ['approvalModalData', id],
    async () => {
      const { data } = await getOneUpskillApprovalList(id)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )
  const queryClient = useQueryClient()

  const { mutate: mutateApproval, isLoading: postApprovalIsLoading } = useMutation(
    (value) => postUpskillApproval(id, value),
    {
      onSuccess: async (response) => {
        await queryClient.invalidateQueries('approvedDataList')
        await queryClient.invalidateQueries('pendingUpskillList')
        await queryClient.invalidateQueries('rejectedDataList')
        await queryClient.invalidateQueries('approvalModalData')
        console.log(response)
        handleClose()
        // remove the below 3 line if want to have a return to dashboard modal on success
        setRejectModalState(false)
        setApproveModalState(false)
        setStatus('')
        setReason('')
      },
      onError: (error) => {
        console.log(error)
        handleClose()
        setStatus('')
        setReason('')
      },
    }
  )
  const [reason, setReason] = useState('')

  const handleSubmit = (item) => {
    if (item === 'approve') {
      mutateApproval({ action: 'approve', ...(reason ? { reason } : {}) })
    }
    if (item === 'reject') {
      mutateApproval({ action: 'reject', ...(reason ? { reason } : {}) })
    }
  }

  if (approvalModalDataIsLoading) {
    return (
      <AdxFormModal
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        handleAction={() => alert('Action button pressed')}
        sxModal={{
          minHeight: { xs: '100vh', lg: 600 },
          maxHeight: null,
          position: 'relative',
          top: { xs: 0, lg: 0 },
          transform: { xs: 'translate(-50%, 0)', lg: 'translate(-50%, 10%)' },
          width: { xs: 1, lg: '500px' },
          borderRadius: '4.5px',
          overflow: 'hidden',
          outline: 'none',
        }}
        customHeader={
          <Box padding={'16px'} display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center" columnGap={1}>
              <Typography variant="subtitle1" color="dark-text.main">
                <Skeleton variant="text" width={'100px'} />
              </Typography>
            </Box>
            <Icon onClick={handleClose} sx={{ cursor: 'pointer' }}>
              close
            </Icon>
          </Box>
        }
      >
        <Box paddingLeft={'20px'}>
          <DetailsText title="Type" text={<Skeleton variant="text" width={'100px'} />} />
          <Box display="flex" alignItems="center">
            <DetailsText
              title="Apply date"
              text={
                <>
                  <Typography as="span">
                    <Skeleton variant="text" width={'100px'} />
                  </Typography>
                </>
              }
            />
          </Box>
          <DetailsText title="Progress" text="" />
          <Box sx={{ my: 2.25, minHeight: '20vh' }}>
            <SingleStepper
              active={false}
              inactiveSubtitle={<Skeleton variant="text" width={'60px'} />}
              name={<Skeleton variant="text" width={'100px'} />}
              date={<Skeleton variant="text" width={'60px'} />}
            />
            {Array.from({ length: 2 }, (_, index) => (
              <SingleStepper
                key={index}
                inactiveSubtitle={<Skeleton variant="text" width={'60px'} />}
                name={<Skeleton variant="text" width={'100px'} />}
                date={<Skeleton variant="text" width={'60px'} />}
                disableLine={index === 1}
              />
            ))}
          </Box>
        </Box>
      </AdxFormModal>
    )
  } else if (!approvalModalData || approvalModalDatadIsError) {
    return (
      <AdxFormModal
        open={isModalOpen}
        onClose={handleClose}
        handleClose={handleClose}
        handleAction={() => alert('Action button pressed')}
        sxModal={{
          minHeight: { xs: '100vh', lg: 600 },
          maxHeight: null,
          position: 'relative',
          top: { xs: 0, lg: 0 },
          transform: { xs: 'translate(-50%, 0)', lg: 'translate(-50%, 10%)' },
          width: { xs: 1, lg: '500px' },
          borderRadius: '4.5px',
          overflow: 'hidden',
          outline: 'none',
        }}
        customHeader={
          <Box padding={'16px'} display="flex" alignItems="center" justifyContent="space-between">
            <Box display="flex" alignItems="center" columnGap={1}>
              <Typography variant="subtitle1" color="dark-text.main">
                Error occured
              </Typography>
            </Box>
            <Icon onClick={handleClose} sx={{ cursor: 'pointer' }}>
              close
            </Icon>
          </Box>
        }
      >
        <Box>
          <AdxEmptyStateV2 icon={<Icon>error</Icon>} title="Not available" />
        </Box>
      </AdxFormModal>
    )
  } else {
    return (
      <>
        <AdxFormModal
          open={isModalOpen}
          onClose={handleClose}
          handleClose={handleClose}
          sx={{
            '&.MuiModal-root': { overflowY: 'auto' },
            paddingY: { xs: 0, lg: '20px' },
          }}
          handleAction={() => alert('Action button pressed')}
          sxModal={{
            minHeight: { xs: '100vh', lg: 600 },
            maxHeight: 600,
            position: 'relative',
            top: { xs: 0, lg: 0 },
            transform: { xs: 'translate(-50%, 0)', lg: 'translate(-50%, 10%)' },
            width: { xs: 1, lg: '500px' },
            borderRadius: '4.5px',
            overflow: 'auto',
            outline: 'none',
          }}
          customHeader={
            <Box padding={'16px'} display="flex" alignItems="center" justifyContent="space-between">
              <Typography variant="subtitle1" color="dark-text.main">
                Course Approval
              </Typography>
              <Icon onClick={handleClose} sx={{ cursor: 'pointer' }}>
                close
              </Icon>
            </Box>
          }
        >
          <Box paddingLeft={'20px'}>
            <DetailsText title="Requester" text={approvalModalData?.requester_name} />
            <DetailsText title="Type" text={approvalModalData?.course_name} />
            <Box display="flex" alignItems="center">
              <DetailsText
                title="Apply date"
                text={
                  <>
                    <Typography as="span">{formatDate(approvalModalData?.apply_date)}</Typography>
                  </>
                }
              />
            </Box>
            {approvalModalData?.reason && (
              <DetailsText title="Reason" text={approvalModalData?.reason} />
            )}
            <Box marginTop={'20px'}>
              <DetailsText title="Progress" text="" />
            </Box>
            <Box sx={{ my: 2.25, minHeight: '20vh' }}>
              <SingleStepper
                active={true}
                activeSubtitle={
                  //   requestItem?.status === 16 ? (
                  //     <Typography
                  //       noWrap
                  //       component="span"
                  //       variant="body2"
                  //       color={'light-gray-text.main'}
                  //       fontWeight="bold"
                  //       textTransform="capitalize"
                  //     >
                  //       Withdrawn
                  //     </Typography>
                  //   ) : (
                  //     'Submitted'
                  //   )
                  'Requested'
                }
                name={
                  //   authData?.staff?.name === submittedLayer?.request_from
                  //     ? 'Me'
                  //     : submittedLayer?.request_from
                  approvalModalData?.approval_status[0]?.requester_name
                }
                imgUrl={approvalModalData?.approval_status[0]?.requester_image}
                date={
                  //   requestItem?.status === 16
                  //     ? format(parseISO(requestItem?.updated_at), `dd/MM/yyyy, hh:mmaa`)
                  //     : submittedLayer?.updated_at
                  //     ? format(parseISO(submittedLayer.updated_at), `dd/MM/yyyy, hh:mmaa`)
                  //     : null
                  formatDateNoDay(approvalModalData?.approval_status[0]?.apply_date)
                }
              />
              <SingleStepper
                disableLine={true}
                active={approvalModalData?.approval_status[1]?.status === 'Approved' ? true : false}
                isRejected={
                  approvalModalData?.approval_status[1]?.status === 'Rejected' ? true : false
                }
                activeSubtitle={approvalModalData?.approval_status[1]?.status}
                inactiveSubtitle={
                  approvalModalData?.approval_status[1]?.status === 'PendingLayerOne'
                    ? 'Awaiting approval'
                    : 'idk check this '
                }
                name={(() => {
                  const status = approvalModalData?.approval_status[1]?.status

                  if (status === 'PendingLayerOne') {
                    return approvalModalData?.approval_status[1]?.waiting_approval_from.map(
                      (item) => item.name
                    )
                  } else if (status === 'Approved') {
                    // Do something for Approved status
                    return approvalModalData?.approval_status[1]?.approved_by.name
                  } else if (status === 'Rejected') {
                    // Do something for Rejected status
                    return approvalModalData?.approval_status[1]?.rejected_by.name
                  }
                })()}
                imgUrl={(() => {
                  const status = approvalModalData?.approval_status[1]?.status

                  if (status === 'PendingLayerOne') {
                    return approvalModalData?.approval_status[1]?.waiting_approval_from.map(
                      (item) => item.profile_image_url
                    )
                  } else if (status === 'Approved') {
                    // Do something for Approved status
                    return approvalModalData?.approval_status[1]?.approved_by.profile_image_url
                  } else if (status === 'Rejected') {
                    // Do something for Rejected status
                    return approvalModalData?.approval_status[1]?.rejected_by.profile_image_url
                  }
                })()}
                date={(() => {
                  const status = approvalModalData?.approval_status[1]?.status

                  if (status === 'Approved') {
                    // Do something for Approved status

                    return formatDateNoDay(approvalModalData?.approval_status[1]?.updated_at)
                  } else if (status === 'Rejected') {
                    // Do something for Rejected status
                    return formatDateNoDay(approvalModalData?.approval_status[1]?.updated_at)
                  }
                })()}
              />
              {/* {fakeData.map((item, index, arr) => (
                <SingleStepper
                  key={index}
                  active={true}
                  activeSubtitle={
                    // item.approval_status === 11 ? (
                    //   <Typography
                    //     noWrap
                    //     component="span"
                    //     variant="body2"
                    //     color={'error.main'}
                    //     fontWeight="bold"
                    //     textTransform="capitalize"
                    //   >
                    //     {item.approval_status_name}
                    //   </Typography>
                    // ) : (
                    //   item.approval_status_name
                    // )
                    item.status
                  }
                  disableLine={fakeData.length - 1 === index}
                  //   inactiveSubtitle={
                  //     requestItem.status === 11 || requestItem.status === 16
                  //       ? 'No further action needed'
                  //       : index - 1 >= 0 && arr[index - 1].approval_status === 1
                  //       ? `Awaiting approval by previous layer`
                  //       : 'Awaiting approval'
                  //   }
                  name={item.name}
                  imgUrl={
                    // item.approval_status === 17 || item.approval_status === 11
                    //   ? item.approved_by_image
                    //   : item.approver.map((el) => (el.image ? el.image : DefaultAvatar)) ||
                    //     DefaultAvatar
                    item.url
                  }
                  date={
                    // item.updated_at ? format(parseISO(item.updated_at), `dd/MM/yyyy, hh:mmaa`) : null
                    item.date
                  }
                />
              ))} */}
            </Box>
            {type === 'pending' && (
              <Box
                sx={{ zIndex: 100 }}
                display="flex"
                flexDirection={{ xs: 'column', lg: 'row' }}
                justifyContent="flex-end"
                alignItems="center"
                position="absolute"
                bottom={0}
                left={0}
                width={1}
                bgcolor="alternate.main"
                padding={3}
                rowGap={1.5}
              >
                <Box display="flex" columnGap={1.5} width={{ xs: 1, lg: 'auto' }}>
                  <AdxButton
                    variant={'outlined'}
                    sx={{
                      width: { xs: 1 / 3, lg: 'auto' },
                      color: 'white.main',
                      borderColor: 'white.main',
                      '&:hover': {
                        backgroundColor: 'alternate.main',
                        color: 'white.main',
                        borderColor: 'white.main',
                      },
                    }}
                    onClick={() => setRejectModalState(true)}
                  >
                    Reject
                  </AdxButton>
                  <AdxButton
                    variant={'contained'}
                    onClick={() => setApproveModalState(true)}
                    disableElevation
                    sx={{
                      width: { xs: 2 / 3, lg: 'auto' },
                      backgroundColor: 'white.main',
                      color: 'alternate.main',
                      borderColor: 'white.main',
                      '&:hover': {
                        backgroundColor: 'white.main',
                        color: 'alternate.main',
                        borderColor: 'white.main',
                      },
                    }}
                  >
                    Approve
                  </AdxButton>
                </Box>
              </Box>
            )}
          </Box>
        </AdxFormModal>
        {/* modal */}
        <ApproveAndReasonModal
          handleToggle={() => setApproveModalState((prevOpen) => !prevOpen)}
          handleUpdate={() => handleSubmit('approve')}
          open={approveModalState}
          isLoading={postApprovalIsLoading}
          setReason={setReason}
          type="Approve"
        />
        <ApproveAndReasonModal
          handleToggle={() => setRejectModalState((prevOpen) => !prevOpen)}
          handleUpdate={() => handleSubmit('reject')}
          open={rejectModalState}
          isLoading={postApprovalIsLoading}
          setReason={setReason}
          type="Reject"
        />

        {/* <AdxInfoModal
          title={
            status === 'success'
              ? `Course request from ${approvalModalData?.approval_status[0]?.requester_name} has been approved.`
              : 'Are you sure you want to approve this?'
          }
          subtitle={
            status === 'success' ? (
              <Typography variant="subtitle1" color="light-gray-text.main">
                Requester will be notified via email.
              </Typography>
            ) : (
              ''
            )
          }
          open={approveModalState}
          onClose={() => setApproveModalState(false)}
          handleClose={() => setApproveModalState(false)}
          muiIcon={status === 'success' ? 'check_circle' : 'info'}
          iconColor="alternate.main"
        >
          {status !== 'success' ? (
            <>
              <AdxButton
                color="alternate"
                fullWidth
                onClick={() => handleSubmit('approve')}
                sx={{
                  '&:hover': {
                    opacity: 0.75,
                  },
                }}
                isLoading={postApprovalIsLoading}
              >
                Approve Request
              </AdxButton>
<AdxButton variant={'ghost'}                color="light-gray-text"
                fullWidth
                onClick={() => setApproveModalState(false)}
              >
                Cancel
              </AdxButton>
            </>
          ) : (
            <AdxButton
              color="alternate"
              fullWidth
              onClick={() => {
                setApproveModalState(false)
                handleClose()
                setStatus('')
              }}
              sx={{
                '&:hover': {
                  opacity: 0.75,
                },
              }}
            >
              Return to dashboard
            </AdxButton>
          )}
        </AdxInfoModal> */}
        {/* <AdxInfoModal
          title={
            status === 'success'
              ? `Course request from ${approvalModalData?.approval_status[0]?.requester_name} has been rejected.`
              : 'Are you sure you want to reject this request?'
          }
          subtitle={
            status === 'success' ? (
              <Typography variant="subtitle1" color="light-gray-text.main">
                Requester will be notified via email.
              </Typography>
            ) : (
              ''
            )
          }
          open={rejectModalState}
          onClose={() => setRejectModalState(false)}
          handleClose={() => setRejectModalState(false)}
          muiIcon="info"
          iconColor="error.main"
        >
          {status !== 'success' ? (
            <>
              <AdxButton
                color="error"
                fullWidth
                onClick={() => handleSubmit('reject')}
                sx={{
                  '&:hover': {
                    opacity: 0.75,
                  },
                }}
                isLoading={postApprovalIsLoading}
              >
                Reject request
              </AdxButton>
<AdxButton variant={'ghost'}                color="light-gray-text"
                fullWidth
                onClick={() => setRejectModalState(false)}
              >
                Cancel
              </AdxButton>
            </>
          ) : (
            <AdxButton
              color="alternate"
              fullWidth
              onClick={() => {
                setRejectModalState(false)
                handleClose()
                setStatus('')
              }}
              sx={{
                '&:hover': {
                  opacity: 0.75,
                },
              }}
            >
              Return to dashboard
            </AdxButton>
          )}
        </AdxInfoModal> */}
      </>
    )
  }
}

export default UpskillApprovalModal
